export const CHANGE_GLOBAL_UNITS = 'CHANGE_GLOBAL_UNITS';
export const FETCH_SECTION_DATA = 'FETCH_SECTION_DATA';
export const LOAD_OUTPUTS = 'LOAD_OUTPUTS';
export const CS_CHANGE_GEOMETRY = 'CS_CHANGE_GEOMETRY';
